export type DynamicsInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type DynamicsInboundContactSyncSettings = {
  autoSync: boolean
  filters: DynamicsInboundContactSyncSettingsFilters
}

export type DynamicsInboundSyncSettings = {
  contact: DynamicsInboundContactSyncSettings
}

export type DynamicsSettingsFormValues = {
  inbound: DynamicsInboundSyncSettings
}

export const dynamicsSettingsDefaultValues: DynamicsSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
}

export type EngageInboundContactSyncSettings = {
  autoSync: boolean
  filters: {
    active?: boolean
    contactType?: string
    tags?: string[]
  }
}

export type EngageInboundSyncSettings = {
  contact: EngageInboundContactSyncSettings
}

export type EngageSettingsFormValues = {
  inbound: EngageInboundSyncSettings
}

export const engageSettingsDefaultValues: EngageSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
}
